import { take } from "lodash";

window.notification = function(bootstrapAlertClass,infoMessage, pinned = false, timer = false, id = false){

    if (window.global_vars.env.WEBSOCKETS_ENABLED) {
        return
    }

    showLMSNotification(bootstrapAlertClass,infoMessage, pinned, timer, id)
}


window.websocketNotification = function(bootstrapAlertClass,infoMessage, pinned = false, timer = false, id = false) {
    showLMSNotification(bootstrapAlertClass,infoMessage, pinned, timer, id)
}

// Chat message notification
window.chatMessageNotification = function(html) {
    showChatNotification(html);
}

function showLMSNotification(bootstrapAlertClass,infoMessage, pinned = false, timer = false, id = false) {

    if (window.User.notificationsDisabled == 1) {
        return
    }

    let pinIcon = document.createElement('i');
    pinIcon.classList.add('fas','fa-thumbtack', 'notification-pin-icon');

    let body = document.querySelector("body");
    let outerContainer = body.querySelector('#notification-container');

    let container = document.createElement('div');
    let message = document.createElement('p');
    let closeButton = document.createElement('span');
    closeButton.classList.add('notification-close-button');
    closeButton.addEventListener('click', function(event){
        removeNotification(event);
    })
    if(id){
        container.id = 'announcement_' + id;
    }
    container.classList.add('alert');
    container.classList.add('notification-message');
    container.classList.add('hide-notification');
    container.classList.add('alert-' + bootstrapAlertClass);

    if (window.popupColors) {
        if (bootstrapAlertClass=='success') {
            container.style.background=window.popupColors.success;
        } else if(bootstrapAlertClass=='danger') {
            container.style.background=window.popupColors.danger;
        } else if (bootstrapAlertClass=='info'){
            container.style.background=window.popupColors.info;
        }
    }


    message.innerHTML = infoMessage;
    closeButton.innerText = 'X';
    container.appendChild(message);

    if(pinned){
        container.appendChild(pinIcon);
    }else{
        container.appendChild(closeButton);
    }

    outerContainer.appendChild(container);

    body.appendChild(outerContainer);
    container.classList.remove('hide-notification');

    // setTimeout(function(){
    //   container.classList.add('hide-notification');
    // },time);

    if(!pinned){
        setTimeout(function(){
            container.classList.add('hide-notification');
        },4000);
    }

    if(timer){
        container = document.querySelector('#announcement_' + id);
        setTimeout(function(){
            container.classList.add('hide-notification');
        },timer * 60000);

        if (container) {
            let notificationDurationContainer = container.querySelector('#notification-duration');
            if(notificationDurationContainer){
                setInterval(function(){
                    --timer;
                    notificationDurationContainer.innerText = timer;
                }, 60000)

            }
        }

    }

    container.addEventListener('transitionend', function(event){
        if(event.propertyName != 'box-shadow'){
            outerContainer.removeChild(container);
        }
    });
}

function showChatNotification(html){

    if (window.User.notificationsDisabled == 1) {
        return
    }

    $('#chat-notification-container').append(html);
}


function removeNotification(event){
  let parent = event.target.parentElement;
  if(parent){
    parent.classList.add('hide-notification');
  }
}

window.setNotificationToSession = function(bootstrapAlertClass, infoMessage){
  sessionStorage.setItem('notification', JSON.stringify({'class': bootstrapAlertClass, 'message': infoMessage}));
}

window.dismissChatNotification = function(id){
    event.preventDefault();
    event.stopPropagation();
    $("#chat-notification-container-"+id).hide();
}

window.showNotificationFromSession = function(){
  let notification = sessionStorage.getItem('notification');

  if(notification){
    let notificationData = JSON.parse(notification);
    window.notification(notificationData.class, notificationData.message);
    sessionStorage.removeItem('notification');
  }
}


// WEBPACK FOOTER //
// ./resources/assets/js/notification.js